import { getMaintenanceList } from '@/services/maintenance.service';

export const MaintenanceModule = {
    state: () => ({
        maintenanceList: [],
    }),
    mutations: {
        setMaintenance(state, data) {
            state.maintenanceList = data;
        },
    },
    actions: {
        async fetchMaintenance({ commit, dispatch }) {
            const { data } = await getMaintenanceList();
            commit('setMaintenance', data);
            dispatch('handleMaintenance');
        },
        handleMaintenance({ state }) {
            const today = new Date().toISOString();
            const hasMaintenance = state.maintenanceList.some((item) => {
                const start = new Date(item.startDate).toISOString();
                const end = new Date(item.endDate).toISOString();
                return today >= start && today <= end;
            });
            const isOffPage =
                hasMaintenance ||
                process?.env?.VUE_APP_MAINTENANCE?.toLowerCase() === 'true';
            if (isOffPage) {
                this._vm.$helpers.redirectStore('/maintenance');
            }
        },
    },
    namespaced: true,
};
